/**
 * Three blinking dots, shown while the interviewer is thinking.
 *
 * Only mounted while a typed answer is waiting on `/score`: chip-only answers
 * are scored locally and never wait. The blink itself lives in `globals.css`
 * behind `prefers-reduced-motion: no-preference`.
 */
export function TypingDots() {
  return (
    <span className="flex items-center gap-1.5 py-1" role="status" aria-label="Thinking">
      <i aria-hidden="true" className="hw-dot bg-hw-mute block size-1.5 rounded-full" />
      <i
        aria-hidden="true"
        className="hw-dot bg-hw-mute block size-1.5 rounded-full [animation-delay:0.16s]"
      />
      <i
        aria-hidden="true"
        className="hw-dot bg-hw-mute block size-1.5 rounded-full [animation-delay:0.32s]"
      />
    </span>
  );
}
